
import { defineAsyncComponent, defineComponent } from "vue";
import HomeView from "../components/home/HomeView.vue";
import WelcomeMessageHome from "@/components/welcomeMessage/WelcomeMessageHome.vue";
import TicketTypes from "@/components/home/TicketTypes.vue";
import PayContinue from "@/components/home/PayContinue.vue";
import AboutEvent from "@/components/home/AboutEvent.vue";
import LoadingHome from "../components/speakers/LoadingHome.vue";
import LoadingProgramHome from "../components/program/LoadingProgramHome.vue";
import LoadingSponsorHome from "../components/sponsors/LoadingHome.vue";
export default defineComponent({
  components: {
    AppHomeView: HomeView,
    WelcomeMessage: WelcomeMessageHome,
    AboutEvent: AboutEvent,
    TicketTypesEvent: TicketTypes,
    SponsorsDetails: defineAsyncComponent(
      () => import("@/components/sponsors/SponsorsDetails.vue")
    ),
    PayContinue: PayContinue,
    SponsorLoadingHome: LoadingSponsorHome,
    SpeakersLoadingHome: LoadingHome,
    ProgramLoadingHome: LoadingProgramHome,
    AppMainSpeakers: defineAsyncComponent(
      () => import("@/components/home/MainSpeakers.vue")
    ),
    ProgramPreview: defineAsyncComponent(
      () => import("@/components/home/ProgramPreview.vue")
    ),
  },
});
